// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RightSidebarManager__container-e58ff6 {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 360px;
  position: relative;
  border-left: 1px solid var(--base-20);
  background-color: var(--base-0);
}`, "",{"version":3,"sources":["webpack://./src/main/RightSidebarManager/RightSidebarManager.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,+BAAA;AACF","sourcesContent":[".container {\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  width: 360px;\n  position: relative;\n  border-left: 1px solid var(--base-20);\n  background-color: var(--base-0);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RightSidebarManager__container-e58ff6`
};
module.exports = ___CSS_LOADER_EXPORT___;
